"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRACKING_PARAMETERS = exports.UserType = exports.Trigger = exports.ProductArea = exports.ProductCode = void 0;
var ProductCode;
(function (ProductCode) {
    ProductCode["PATIENT_FUNNEL"] = "PatientFunnel";
    ProductCode["MARKETING_SITE"] = "MKTG_Site";
    ProductCode["PROVIDER_ACCESS"] = "ProviderAccess";
    ProductCode["ONBOARDING_PORTAL"] = "OnboardingPortal";
    // ...
})(ProductCode || (exports.ProductCode = ProductCode = {}));
var ProductArea;
(function (ProductArea) {
    ProductArea["MARKETING_SITE"] = "Marketing Site";
    ProductArea["ENTRY_FORM"] = "Entry Form";
    ProductArea["BOOKING_UI"] = "Booking UI";
    ProductArea["ONBOARDING_UI"] = "Onboarding UI";
    ProductArea["REGISTRATION_FORM"] = "Registration Form";
    ProductArea["DIRECT_BOOKING_TOOL"] = "Direct Booking Tool";
    // used on booking-ui /providers
    ProductArea["PUBLIC_PROVIDER_PROFILES"] = "Public Provider Profiles";
    // used on booking-ui /therapists
    ProductArea["PROVIDER_DIRECTORY"] = "Provider Directory";
})(ProductArea || (exports.ProductArea = ProductArea = {}));
var Trigger;
(function (Trigger) {
    // Interaction: When a direct intentional user action is the cause of
    // this event that is not a simple navigation. E.g. Submitted form or
    // changed password
    Trigger["INTERACTION"] = "Interaction";
    // Page view: When the event was an indirect result of viewing something.
    // E.g. auto-assigning a provider or appointment because the user has an
    // existing provider already
    // @note Because of usage limits, we do not want to record page views
    //   as a separate action, this is only for indirect consequences that
    //   result in a change in something either for the user or for our
    //   systems
    Trigger["PAGE_LOAD"] = "PageLoad";
    // form submission
    Trigger["SUBMISSION"] = "Submission";
    // unexpected errors as a result of user interaction
    Trigger["SUBMISSION_ERROR"] = "SubmissionError";
    // Any sort of feedback (success, warning, waiting, etc) show to user
    // as a result of a form submission
    Trigger["SUBMISSION_FEEDBACK"] = "SubmissionFeedback";
    // general unexpected errors
    Trigger["SERVER_ERROR"] = "ServerError";
    // Automation: Some automation or tool was the cause of this event
    Trigger["AUTOMATION"] = "Automation";
    // creating a new reg link
    Trigger["CREATE_REGISTRATION"] = "CreateRegistration";
    // Custom Email Capture event
    Trigger["EMAIL_CAPTURE"] = "EmailCapture";
    // Marketing site event triggers
    Trigger["OUTBOUND_LINK_CLICKED"] = "Outbound_link_clicked";
    Trigger["INTERNAL_LINK_CLICKED"] = "Internal_link_clicked";
    Trigger["ANCHOR_LINK_CLICKED"] = "Anchor_link_clicked";
    Trigger["AVOB_BANNER_CLICKED"] = "avob_banner_clicked";
    Trigger["FORM_SUBMITTED"] = "Form_submitted";
    Trigger["FORM_INTERACTION"] = "Form_Interaction";
    Trigger["USER_GROUP"] = "user_group";
    // Marketing site UTM initial page view stop gap. See:
    // https://linear.app/pathccm/issue/DOG-1754/distinguish-direct-traffic-vs-missing-utms-in-amplitude
    Trigger["UTM_PAGE_LOAD"] = "UTM_Page_Viewed";
})(Trigger || (exports.Trigger = Trigger = {}));
var UserType;
(function (UserType) {
    // Patient or potential patient
    UserType["PATIENT"] = "Patient";
    // Provider, which can be any sub-type (e.g. therapist)
    UserType["PROVIDER"] = "Provider";
    // Insurer, not currently in-use
    UserType["INSURER"] = "Insurer";
    // Operator or any internal non-developer
    UserType["OPERATOR"] = "Operator";
    // Developer; mostly relevant for backfills or manual intervention
    UserType["DEVELOPER"] = "Developer";
    // System, either first-party or third-party
    UserType["SYSTEM"] = "System";
    // Third-party agent (e.g. a call center agent)
    UserType["AGENT"] = "Agent";
})(UserType || (exports.UserType = UserType = {}));
// any params added here must be added to validateSearchParams
// in booking-ui/src/common/search.ts
exports.TRACKING_PARAMETERS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "gclid",
    "fbclid",
    "msclid",
    "ttclid",
    "referral_url",
    "lead_source",
    "landing_page_url",
];
